import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Link as GatsbyLink } from 'gatsby';
import { styled, useTheme } from '@mui/material';
import { Post } from 'src/models/fragments';

interface Props {
  post: NonNullable<Post>;
  onClick?: (path: string) => void;
}
const SimplePostItem = ({ post, onClick }: Props) => {
  const { shape, palette } = useTheme();

  if (post.fields?.path == null) {
    return null;
  }

  const path = post.fields.path;
  const category = post.frontmatter?.categories?.join('/') ?? '';
  const title = post.frontmatter?.title ?? '';
  const date = post.frontmatter?.date;

  return (
    <Link to={path}>
      <Grid
        container
        onClick={() => onClick?.(path)}
        sx={{
          borderRadius: shape.borderRadius,
          transition: 'opacity 0.3s ease-in-out',
          '&:hover': {
            opacity: 0.6,
          },
        }}
      >
        <Grid item xs={true}>
          <Typography color="textSecondary" variant="caption" fontFamily={`"Birthstone", serif`}>
            {date}
          </Typography>
          <Typography variant="body2">{title}</Typography>
          <Typography color="textSecondary" variant="caption">
            {category}
          </Typography>
        </Grid>
      </Grid>
    </Link>
  );
};

const Link = styled(GatsbyLink)({
  color: 'inherit',
  textDecoration: 'none',
});

export default SimplePostItem;
